import { render, staticRenderFns } from "./HtmlHistoryTable.vue?vue&type=template&id=4123f0a6&scoped=true"
import script from "./HtmlHistoryTable.vue?vue&type=script&lang=js"
export * from "./HtmlHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./HtmlHistoryTable.vue?vue&type=style&index=0&id=4123f0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4123f0a6",
  null
  
)

export default component.exports